import { render, staticRenderFns } from "./evidence-web.vue?vue&type=template&id=7c4cd620&scoped=true&"
import script from "./evidence-web.vue?vue&type=script&lang=js&"
export * from "./evidence-web.vue?vue&type=script&lang=js&"
import style0 from "./evidence-web.vue?vue&type=style&index=0&id=7c4cd620&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4cd620",
  null
  
)

export default component.exports